import { ADMIN_API } from "./adminApi";
import { AdminLoginResponse, AdminMeResponse } from "./adminAuth.types";

export const loginAdmin = async (email: string, senha: string) => {
  const { data } = await ADMIN_API.post<AdminLoginResponse>("/api/admin/login", { email, senha });
  return data;
};

export const meAdmin = async () => {
  const { data } = await ADMIN_API.get<AdminMeResponse>("/api/admin/me");
  return data;
};

export const logoutAdmin = async () => {
  const { data } = await ADMIN_API.post("/api/admin/auth/logout");
  return data;
};
